import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import React, { Component } from 'react';
import invariant from 'invariant';
import hoistStatics from 'hoist-non-react-statics';
import { routerMiddleware } from 'connected-react-router';
import { connect } from 'react-redux';
import { withUrlGeneratorMiddleware } from '@folklore/react-container';
import createPropsContainer from './createPropsContainer';
import createStoreContainer from './createStoreContainer';
import createRouterContainer from './createRouterContainer';
import createUrlGeneratorContainer from './createUrlGeneratorContainer';
import createHistoryContainer from './createHistoryContainer';
import createIntlContainer from './createIntlContainer';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default function createAppContainer(opts) {
  var options = _objectSpread({
    propTypes: null,
    defaultProps: null,
    withRef: false,
    mapStateToProps: null,
    getUrlGeneratorRoutes: null,
    getIntlLocale: null,
    getIntlMessages: null,
    createHistory: null,
    getStoreReducers: null,
    getStoreInitialState: null,
    getStoreMiddlewares: function getStoreMiddlewares(props) {
      return [routerMiddleware(props.history), withUrlGeneratorMiddleware(props.urlGenerator)];
    },
    storeHasChanged: null
  }, opts);

  var withRef = options.withRef,
      propTypes = options.propTypes,
      defaultProps = options.defaultProps,
      createHistory = options.createHistory,
      mapStateToProps = options.mapStateToProps,
      getUrlGeneratorRoutes = options.getUrlGeneratorRoutes,
      getIntlLocale = options.getIntlLocale,
      getIntlMessages = options.getIntlMessages,
      getStoreReducers = options.getStoreReducers,
      getStoreInitialState = options.getStoreInitialState,
      getStoreMiddlewares = options.getStoreMiddlewares,
      storeHasChanged = options.storeHasChanged;
  return function (WrappedComponent) {
    var Container =
    /*#__PURE__*/
    function (_Component) {
      _inherits(Container, _Component);

      function Container() {
        _classCallCheck(this, Container);

        return _possibleConstructorReturn(this, _getPrototypeOf(Container).apply(this, arguments));
      }

      _createClass(Container, [{
        key: "render",
        value: function render() {
          var _this = this;

          var props = _objectSpread({}, this.props);

          if (withRef) {
            props.ref = function (c) {
              _this.wrappedInstance = c;
            };
          }

          return React.createElement(WrappedComponent, props);
        }
      }], [{
        key: "getWrappedInstance",
        value: function getWrappedInstance() {
          invariant(withRef, 'To access the wrapped instance, you need to specify `{ withRef: true }` as the second argument of the createAppContainer() call.');
          return this.wrappedInstance;
        }
      }]);

      return Container;
    }(Component);

    Container.displayName = "AppContainer(".concat(getDisplayName(WrappedComponent), ")");
    Container.WrappedComponent = WrappedComponent;
    var AppContainer = hoistStatics(Container, WrappedComponent);
    var RouterContainer = createRouterContainer(null, {
      withRef: withRef
    })(AppContainer);
    var IntlContainer = createIntlContainer(getIntlLocale, getIntlMessages, {
      withRef: withRef
    })(RouterContainer); // prettier-ignore

    var ConnectedContainer = mapStateToProps !== null ? connect(mapStateToProps)(IntlContainer) : IntlContainer;
    var StoreContainer = createStoreContainer(getStoreReducers, getStoreInitialState, getStoreMiddlewares, storeHasChanged, {
      withRef: withRef
    })(ConnectedContainer);
    var HistoryContainer = createHistoryContainer(createHistory, {
      withRef: withRef
    })(StoreContainer);
    var UrlGeneratorContainer = createUrlGeneratorContainer(getUrlGeneratorRoutes, {
      withRef: withRef
    })(HistoryContainer);
    var PropsContainer = propTypes !== null || defaultProps !== null ? createPropsContainer(propTypes, defaultProps, {
      withRef: withRef
    })(UrlGeneratorContainer) : UrlGeneratorContainer;
    return PropsContainer;
  };
}


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/react-app/es/createAppContainer.js
// module id = null
// module chunks = 